// extracted by mini-css-extract-plugin
export var deliveryRow = "_jl-a";
export var fixedHeight = "_jl-4";
export var freightLogo = "_jl-9";
export var fullWidth = "_jl-3";
export var priceColumn = "_jl-5";
export var radioSelected = "_jl-7";
export var radioUnselected = "_jl-6";
export var selectedOption = "_jl-2";
export var selectedOptionContainer = "_jl-1";
export var selection = "_jl-0";
export var tallSkeletonText = "_jl-8";